import { getAllRegions } from 'web-common-kit/data';
import { normalizeRegionOptionValues } from './regionValueNormalizer';

export {
    findRegionByCode,
    formatArea,
    getCities,
    getDistrictNameByCode,
    getDistricts,
    getLocationNameByCode,
    getProvinceNameByCode,
    getCityNameByCode,
    getProvinces,
    getRegionPath,
    searchRegion,
} from 'web-common-kit/data';

/** Cascader options：模块加载时深拷贝一次，并保持旧 areas.js 的字符串编码契约 */
export const regionOptions = normalizeRegionOptionValues(getAllRegions());
